import UserService from '../../../services/UserService';

export default {
    namespaced: true,
    actions: {
       registerNewUser: ({dispatch}, userData) => {
        return new Promise((resolve, reject) => {
           UserService.newUser(userData).then(res => {
                dispatch('getUserList')
                resolve(res)
           }).catch((err) => {
               reject(err)
           })
        })
       }
    },
}